import React from "react";
import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { StoriesRoutes } from "./constants/routes";
// import { StoriesRoute } from "./constants/routes";

const Stories = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {StoriesRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/stories" />
      </Switch>
    </>
  );
};
export default Stories